/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ referenceId: NonNullable<unknown> }} Page_Error_ReferenceInputs */

const sv_page_error_reference = /** @type {(inputs: Page_Error_ReferenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Referens: ${i?.referenceId}`)
};

const en_page_error_reference = /** @type {(inputs: Page_Error_ReferenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reference: ${i?.referenceId}`)
};

/**
* | output |
* | --- |
* | "Reference: {referenceId}" |
*
* @param {Page_Error_ReferenceInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_error_reference = /** @type {((inputs: Page_Error_ReferenceInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Error_ReferenceInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_error_reference(inputs)
	return en_page_error_reference(inputs)
});